define('editor/edit/layers/edit/boundary',['jquery', 'durandal/app', 'plugins/http', 'knockout', 'knockout-mapping', 'no-ui-slider', 'tinycolorpicker'], function ($, app, http, ko, komapping, noUiSlider) {
    var viewmodel = function () {
        var self = this;

        self.layer = null;
        self.backup = null;
        self.name = ko.observable();
        self.isDirty = true; // assume edited

        // editable vector style properties
        self.fillColor = ko.observable('#000000');
        self.fillOpacity = ko.observable(100);
        self.strokeColor = ko.observable('#000000');
        self.strokeWeight = ko.observable(1);
        self.strokeOpacity = ko.observable(100);
        self.selectedTextSize = ko.observable('normal');
        self.labelText = ko.observable('');
        self.labelLat = ko.observable(0);
        self.labelLon = ko.observable(0);
        self.labelVisible = ko.observable(true);
        self.labelTextColor = ko.observable();
        self.labelShadowColor = ko.observable();
        self.textShadow = ko.observable(false);


        self.activate = function (editorMapId, layer, backToListFunc) {
            self.editorMapId = editorMapId;
            self.layer = layer;
            self.backup = ko.toJS(self.layer);
            self.exit = backToListFunc;
            self.name(self.layer.name());

            var state = self.layer.state();
            self.fillColor(state.fillColor());
            self.fillOpacity(state.fillOpacity() * 100);
            self.strokeColor(state.color());
            self.strokeWeight(state.weight());
            self.strokeOpacity(state.opacity() * 100);
            self.selectedTextSize(state.textSize());
            self.labelText(state.labelText().unescapeNewLines());
            self.labelLat(state.labelLat());
            self.labelLon(state.labelLon());
            self.labelVisible(state.labelVisible());
            self.labelTextColor(state.labelTextColor());
            self.labelShadowColor(state.textShadowColor());
            self.textShadow(state.textShadow() === "on");

            self.changes = ko.computed(function () {
                return self.fillColor() +
                    self.fillOpacity() +
                    self.strokeColor() +
                    self.strokeWeight() +
                    self.strokeOpacity() +
                    self.labelText() +
                    self.labelLat() +
                    self.labelLon() +
                    self.labelVisible() +
                    self.selectedTextSize() +
                    self.textShadow() +
                    self.labelTextColor() +
                    self.labelShadowColor();
            });

            self.changes.subscribe(function () {
                state.fillColor(self.fillColor());
                state.fillOpacity(self.fillOpacity() / 100);
                state.color(self.strokeColor());
                state.opacity(self.strokeOpacity() / 100);
                state.weight(self.strokeWeight());
                state.labelText(self.labelText());
                state.labelLat(self.labelLat());
                state.labelLon(self.labelLon());
                state.labelVisible(self.labelVisible());
                state.textSize(self.selectedTextSize());
                state.textShadow(self.textShadow() ? "on" : "off");
                state.labelTextColor(self.labelTextColor());
                state.textShadowColor(self.labelShadowColor());
                app.trigger("layers:updated", [self.layer]);
            });

            app.trigger('layer:editing', self.layer);

            app.on('marker:moved', self.onMarkerMoved);
            app.on('layers:drawing', function () {
                self.cancelCommand();
            });
        };

        self.deactivate = function () {
            app.off('marker:moved', self.onMarkerMoved);
        };

        self.compositionComplete = function () {
            // set up jQuery plugins etc..
            var fillSlider = $('.slider-fill'),
                fillSliderStart = self.fillOpacity(),
                fillColorPicker,
                strokeSlider = $('.slider-stroke'),
                strokeSliderStart = self.strokeOpacity(),
                strokeColorPicker,
                labelColorPicker,
                labelShadowColorPicker;


            if (fillSlider.length) {
                noUiSlider.create(fillSlider.get(0),
            {
                start: fillSliderStart,
                step: 1,
                tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                fillSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = fillSlider.get(0).noUiSlider.get();
                    self.fillOpacity(newValue);
                });
            }

            if (strokeSlider.length) {
                noUiSlider.create(strokeSlider.get(0),
            {
                start: strokeSliderStart,
                step: 1,
                tooltips: true,
                    connect: "lower",
                    orientation: "horizontal",
                    range: {
                        'min': 0,
                        'max': 100
                    },
                    serialization: {
                        format: {
                            decimals: 0
                        }
                    }
                });

                strokeSlider.get(0).noUiSlider.on('change', function () {
                    var newValue = strokeSlider.get(0).noUiSlider.get();
                    self.strokeOpacity(newValue);
                });
            }

            strokeColorPicker = $('.color-picker-stroke').tinycolorpicker();
            strokeColorPicker.data().plugin_tinycolorpicker.setColor(self.strokeColor());
            strokeColorPicker.bind("change", function () {
                var newColor = $(this).data().plugin_tinycolorpicker.colorHex;
                self.strokeColor(newColor);
            });

            fillColorPicker = $('.color-picker-fill').tinycolorpicker();
            fillColorPicker.data().plugin_tinycolorpicker.setColor(self.fillColor());
            fillColorPicker.bind("change", function () {
                var newColor = $(this).data().plugin_tinycolorpicker.colorHex;
                self.fillColor(newColor);
            });

            labelColorPicker = $('.color-picker-text').tinycolorpicker();
            labelColorPicker.data().plugin_tinycolorpicker.setColor(self.labelTextColor());
            labelColorPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelTextColor(newColour);
            });

            labelShadowColorPicker = $('.color-picker-shadow').tinycolorpicker();
            labelShadowColorPicker.data().plugin_tinycolorpicker.setColor(self.labelShadowColor());
            labelShadowColorPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.labelShadowColor(newColour);
            });

        };

        self.onMarkerMoved = function (data) {
            if (self.layer.id() === data.id) {
                self.labelLat(data.newPos.lat);
                self.labelLon(data.newPos.lng);
            }
        };

        self.detached = function () {
            if (self.isDirty) {
                self.cancelCommand();
            }
        };

        self.cancelCommand = function () {
            // revert to initial layer state
            var mapped = komapping.fromJS(self.backup.state);

            delete mapped['__ko_mapping__'];

            self.layer.name(self.backup.name);
            self.layer.state(mapped);
            app.trigger("layer:saved", self.layer);

            self.isDirty = false;
            self.exit();
        };

        self.saveCommand = function () {
            self.layer.name(self.name());

            self.save()
                .done(function (response) {
                    if (response.success) {
                        app.trigger('layer:saved', self.layer);
                        self.isDirty = false;
                        self.exit();
                    } else {
                        self.saveError();
                    }
                }).fail(self.saveError);
        };

        self.save = function () {
            var url = '/api/editor/layers',
                data = {
                    editorMapId: self.editorMapId,
                    layerId: self.layer.id(),
                    order: self.layer.order(),
                    name: self.layer.name(),
                    visible: self.layer.visible(),
                    state: self.layer.state()
                };

            return http.post(url, data);
        };
    };

    return viewmodel;
});

